import React, { Component } from "react";
import DialogBaseView from '../../../../components/DialogBase/DialogBaseView';
import DialogPromptView from "../../../../components/DialogBase/components/DialogPrompt/DialogPromptView";
import TranslationView from "../../../../../../components/translation/TranslationView";
import DialogMultilineTextInputView from "../../../../components/DialogBase/components/DialogMultilineTextInput/DialogMultilineTextInputView";
import CancelCheckDialogViewProps from "./CancelCheckDialogViewProps";
import CancelCheckDialogViewState from "./CancelCheckDialogViewState";

export default class CancelCheckDialogView extends Component<CancelCheckDialogViewProps, CancelCheckDialogViewState> {

    state = {
        comment :  ''
    };

    render() {
        return (
            <DialogBaseView title='editOrCancelCheck' subtitle='cancelCheck' onSubmit={this.onSubmit} error={this.props.error}>
                <DialogPromptView>
                    <TranslationView>
                        pressSendToCancel
                    </TranslationView>
                </DialogPromptView>

                <DialogMultilineTextInputView onChange={this.onChange} rows={4} placeholder='addComment' />
            </DialogBaseView>
        );  
    }

    onSubmit = (done : () => void) => {
        this.props.onSubmit(this.state, done);
    }

    onChange = (comment : string) => {
        this.setState({
            comment : comment
        });
    }
}